module.exports = __webpack_public_path__ + "img/icon16.a5795632.a5795632.svg";